import { Component } from '@angular/core';

@Component({
  selector: 'si-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
})
export class NotFoundComponent { }